import { render } from "./ContactForms.vue?vue&type=template&id=8a082998&scoped=true"
import script from "./ContactForms.vue?vue&type=script&lang=js"
export * from "./ContactForms.vue?vue&type=script&lang=js"

import "./ContactForms.vue?vue&type=style&index=0&id=8a082998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a082998"]])

export default __exports__